module.exports = __webpack_public_path__ + "img/eoy-giving-donate-4.329b517f.jpg";